import { surveyRoutes } from './SurveyRoutes';

export const moduleRoutesList = [surveyRoutes];
